import AbstractModel from '../AbstractModel';

class EquipmentInputModel extends AbstractModel {}

export default EquipmentInputModel;
